import inViewport from '@resources/js/helpers/inViewport'
import { isMobile } from '@resources/js/helpers/media'
import { ToggleWithSmooth } from '@resources/js/ui/Toggle'
import initJSLinks from '@resources/js/js-links'

initJSLinks()

if (isMobile()) {
	const footerElement = document.querySelector('.js-footer')

	inViewport(footerElement, () => {
		const triggerToggleElements = footerElement.querySelectorAll(
			'.js-footer-trigger-toggle'
		)

		if (!triggerToggleElements.length) return

		triggerToggleElements.forEach(toggle => {
			const targetToggleElement = toggle.nextElementSibling

			new ToggleWithSmooth(toggle, {
				target: targetToggleElement,
				transitionTime: '0.3s',
			})
		})
	})
}
